/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import type { TaskDetails } from '@/task-manager/entities/task-details';
import type { TaskFile } from '@/task-manager/entities/task-file';

import {
  type BodyOf,
  tasksV1CardsFilesDeleteDestroy,
  tasksV1CardsFilesDownloadRetrieve,
} from '../fetch-client';
import { useFetchOpts } from '../use-fetch-opts';

export namespace DownloadTaskFile {
  export type Input = { task: TaskDetails; file: TaskFile };
  export type Output = { file: File };

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof tasksV1CardsFilesDeleteDestroy> {
    return {
      uuid: input.task.id,
      fileId: input.file.id,
    };
  }

  function outputFromResult(result: Blob, input: Input): Output {
    return { file: new File([result], input.file.name) };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        const result = await ok(tasksV1CardsFilesDownloadRetrieve(body, opts));
        const output = outputFromResult(result, input);
        return output;
      },
    });
  }
}
